import React, { useEffect } from "react";
import useIsSignedIn from "../../hooks/useIsSignedIn";
import { useDispatch, useSelector } from "react-redux";
import {
  loadCategories,
  loadSites,
  loadWorkshops,
  setUser,
} from "../../state/workshopSlice";
import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import style from "./ContentArea.module.css";
import mgtStyle from "../../style/mgtStyle.module.css";
import Notifications from "./Notifications/Notifications";
import { Login } from "@microsoft/mgt-react";
import { Providers } from "@microsoft/mgt-element";
import WorkshopAdmin from "../Workshop/WorkshopAdmin";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import EditWorkshop from "../Workshop/EditWorkshop/EditWorkshop";
import ViewWorkshop from "../Workshop/ViewWorkshop/ViewWorkshop";
import NoWorkshopSelected from "../Workshop/NoWorkshopSelected/NoWorkshopSelected";
import RegistrationList from "../Workshop/RegistrationList/RegistrationList";
import useGetCurrentUser from "../../hooks/useGetCurrentUser";
import ListContainer from "../WorkshopList/ListContainer";

const ContentArea = () => {
  const dispatch = useDispatch();
  const isSignedIn = useIsSignedIn();
  const user = useGetCurrentUser();

  const doStartup = () => {
    dispatch(loadCategories());
    dispatch(loadSites());

    //get the roles for the current user and put it in the state
    //then load the workshops for this user
    if (user) {
      Providers.globalProvider.publicClientApplication
        .acquireTokenSilent({ account: user })
        .then((response) => {
          dispatch(setUser(response.account));
        })
        .then(() => {
          dispatch(loadWorkshops());
        });
    }
  };

  useEffect(() => {
    if (isSignedIn) {
      doStartup();
    }
  }, [isSignedIn]);

  return (
    <Paper
      elevation={3}
      sx={{
        width: { xs: "100%", md: "90%", lg: "80%" },
        p: 1,
        mx: "auto",
      }}
      className={style.body}
    >
      {isSignedIn ? (
        <>
          <Notifications />
          <Box className={style.list}>
            <BrowserRouter>
              <ListContainer />
              <Routes>
                <Route path="*" element={<WorkshopAdmin />}>
                  <Route path="edit/:id" element={<EditWorkshop />} />
                  <Route path="edit/new" element={<EditWorkshop />} />
                  <Route path="view/:id" element={<ViewWorkshop />} />
                  <Route path="reg/:id" element={<RegistrationList />} />
                  <Route path="*" element={<NoWorkshopSelected />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ textAlign: "center", margin: "2rem" }}>
            <Typography sx={{ marginBottom: "2rem" }} variant="h2">
              Please sign in
            </Typography>
            <Login className={mgtStyle.login} />
          </Box>
        </>
      )}
    </Paper>
  );
};

export default ContentArea;
